(() => {
  const manifestUrl = document.currentScript?.dataset.wtZoomManifest;
  if (!manifestUrl) return;

  const staticCardZoom = document.body.classList.contains('wt-card-detail-view');
  const selector = '.product-card-wrapper .media.media--hover-effect > img:first-child, .product-media-container.media-type-image .product__media > img';
  const tracked = new Map();
  const initialized = new WeakSet();
  let bounds = null;
  let resizeFrame = 0;

  function productHandle(image) {
    const cardLink = image.closest('.product-card-wrapper')?.querySelector('a[href*="/products/"]');
    const path = cardLink ? new URL(cardLink.href, location.href).pathname : location.pathname;
    return path.match(/\/products\/([^/?#]+)/)?.[1] || '';
  }

  function imageFilename(image) {
    const source = image.currentSrc || image.src;
    if (!source) return '';
    const filename = decodeURIComponent(new URL(source, location.href).pathname.split('/').pop());
    return filename.replace(/_\d+x\d*(?=\.[^.]+$)/, '');
  }

  function setZoom(image, box) {
    const frame = image.parentElement;
    if (!frame || !image.naturalWidth || !image.naturalHeight) return;
    const width = frame.clientWidth || image.naturalWidth;
    const height = frame.clientHeight || image.naturalHeight;

    const fit = getComputedStyle(image).objectFit === 'contain'
      ? Math.min(width / image.naturalWidth, height / image.naturalHeight)
      : Math.max(width / image.naturalWidth, height / image.naturalHeight);
    const renderedWidth = image.naturalWidth * fit;
    const renderedHeight = image.naturalHeight * fit;
    const left = (width - renderedWidth) / 2;
    const top = (height - renderedHeight) / 2;
    const centerX = left + (box[0] + box[2] / 2) * renderedWidth;
    const centerY = top + (box[1] + box[3] / 2) * renderedHeight;
    const artworkWidth = box[2] * renderedWidth;
    const artworkHeight = box[3] * renderedHeight;
    const fitScale = Math.min(0.9 * width / artworkWidth, 0.9 * height / artworkHeight);
    const scale = Math.max(1.5, fitScale);
    const originX = (width / 2 - scale * centerX) / (1 - scale);
    const originY = (height / 2 - scale * centerY) / (1 - scale);

    image.style.setProperty('--wt-detail-scale', scale.toFixed(3));
    image.style.setProperty('--wt-detail-origin-x', `${(originX / width * 100).toFixed(2)}%`);
    image.style.setProperty('--wt-detail-origin-y', `${(originY / height * 100).toFixed(2)}%`);
    const card = image.closest('.product-card-wrapper');
    if (frame.clientWidth && !(staticCardZoom && card)) {
      const neededScale = image.dataset.wtZoomUpgraded ? scale : card ? 1.5 : 1;
      const neededSize = `${Math.ceil(frame.clientWidth * neededScale)}px`;
      if (image.sizes !== neededSize) image.sizes = neededSize;
    }
  }

  function upgradeImage(image) {
    if (!image.parentElement?.clientWidth) return;
    const scale = Number.parseFloat(image.style.getPropertyValue('--wt-detail-scale')) || 2.1;
    image.dataset.wtZoomUpgraded = 'true';
    image.sizes = `${Math.ceil(image.parentElement.clientWidth * scale)}px`;
  }

  function syncImage(image) {
    const handle = productHandle(image);
    const filename = imageFilename(image);
    const designId = filename.match(/^wt-(\d{4})(?:_|-)/)?.[1];
    const slots = [...filename.matchAll(/[-_](0[1-9]|1[0-2])[-_]/g)];
    const slot = slots.at(-1)?.[1];
    const box = bounds[`${handle}/${filename}`]
      || bounds[`staged/${handle}/${filename}`]
      || (designId && slot ? bounds[`${designId}/${slot}`] : null);
    if (!Array.isArray(box) || box.length !== 4 || box.some((value) => !Number.isFinite(value)) || box[2] <= 0 || box[3] <= 0) {
      tracked.delete(image);
      return;
    }
    tracked.set(image, box);
    if (image.complete && image.naturalWidth) setZoom(image, box);
  }

  function scanImages() {
    if (!bounds) return;
    document.querySelectorAll(selector).forEach((image) => {
      if (initialized.has(image)) return;
      initialized.add(image);
      const cardTarget = image.closest('.product-card-wrapper');
      const hoverTarget = cardTarget || image.closest('.product__modal-opener--image');
      if (hoverTarget && !(staticCardZoom && cardTarget)) {
        hoverTarget.addEventListener('pointerenter', () => upgradeImage(image), { once: true });
        hoverTarget.addEventListener('focusin', () => upgradeImage(image), { once: true });
      }
      image.addEventListener('load', () => syncImage(image));
      syncImage(image);
    });
  }

  function refreshZoom() {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(() => {
      scanImages();
      tracked.forEach((box, image) => {
        if (image.isConnected) syncImage(image);
        else tracked.delete(image);
      });
    });
  }

  fetch(manifestUrl, { cache: 'force-cache' })
    .then((response) => {
      if (!response.ok) throw new Error('Design zoom data unavailable');
      return response.json();
    })
    .then((data) => {
      bounds = data;
      scanImages();
      window.addEventListener('resize', refreshZoom, { passive: true });
      document.addEventListener('change', refreshZoom);
      document.addEventListener('shopify:section:load', refreshZoom);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, refreshZoom);
      }
    })
    .catch(() => {});
})();
